module.exports = __webpack_public_path__ + "img/full6-min.8ea80b96.png";